import { wafersWithControlEndpoints } from 'service/sources/vehicles/waferswithcontrol'

import { axiosService } from '../../../index'

const search = (values) => {
  return axiosService.post(wafersWithControlEndpoints.SEARCH, values)
}

const list = (options) => {
  return axiosService.get(wafersWithControlEndpoints.LIST + options)
}
// const list = (options) => {
//   return axiosService.get(wafersWithControlEndpoints.LIST + '?estado=Todos')
// }

const create = (body) => {
  return axiosService.post(wafersWithControlEndpoints.CREATE, body)
}

const details = (id) => {
  return axiosService.get(wafersWithControlEndpoints.DETAILS + '/' + id)
}

const uploadFile = (file, id, dominio, type) => {
  return axiosService.uploadSingleFile(
    wafersWithControlEndpoints.UPLOAD + `?id=${id}&tipo=${type}&dominio=${dominio}`,
    file
  )
}

const deleteFile = (type, id, dominio, body) => {
  return axiosService.post(
    wafersWithControlEndpoints.DELETE_FILE + '?tipo=' + type + '&id=' + id + '&dominio=' + dominio,
    body
  )
}

const finalize = (id) => {
  return axiosService.post(wafersWithControlEndpoints.FINALIZE + '/' + id)
}

const deleteVeh = (id) => {
  return axiosService.del(wafersWithControlEndpoints.DELETE + '/' + id)
}

const exportVeh = () => {
  return axiosService.get(wafersWithControlEndpoints.EXPORT)
}

const edit = (id, body) => {
  return axiosService.put(wafersWithControlEndpoints.EDIT + '/' + id, body)
}

const download = (id) => {
  return axiosService.getPDF(wafersWithControlEndpoints.DOWNLOAD + id)
}

export const wafersWithControlInterface = {
  search,
  create,
  list,
  details,
  uploadFile,
  deleteFile,
  finalize,
  deleteVeh,
  exportVeh,
  edit,
  download,
}
